(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('BannerImageDeleteController',BannerImageDeleteController);

    BannerImageDeleteController.$inject = ['$uibModalInstance', 'entity', 'BannerImage'];

    function BannerImageDeleteController($uibModalInstance, entity, BannerImage) {
        var vm = this;

        vm.bannerImage = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            BannerImage.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
